import { render, staticRenderFns } from "./ReviewYourAnswersCM.vue?vue&type=template&id=2c684d4a"
import script from "./ReviewYourAnswersCM.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersCM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports